import { useState } from "react";
import { bool, object } from "prop-types";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { BreakdownColumns } from "@repo/utils";
import { useEstimateEditorSettings, useEstimateStructure } from "@tools";
import { AddButtonFull, Alert, InfoLabel } from "@components";
import { Grid } from "@material-ui/core";
import { ColumnSettingEntry } from "./components/ColumnSettingEntry";

export const BreakdownColumnsList = observer(({
  section,
  noDescriptionAdding,
}) => {
  const { t } = useTranslation();
  const { hasSellerPrivileges } = useEstimateEditorSettings();
  const structure = useEstimateStructure();
  
  const [ addAlertVisible, showAddAlert ] = useState(false);
  // const [ pinAlertData, setPinData ] = useState(null);
  const [ removeAlertData, setRemoveData ] = useState(null);
  
  const {
    usedBreakdownColumns,
    lastDescriptionColumnIndex,
    usedAllDescriptionColumns,
  } = (section || structure);
  
  const filteredBreakdownColumns = usedBreakdownColumns
    .filter(({ name }) => name !== BreakdownColumns.PRICE || hasSellerPrivileges );
  
  const handleColumnAdd = () => {
    if(section) {
      showAddAlert(true);
      return;
    }
    
    addNewColumn(section?.id);
  }
  const handleColumnPin = (columnId, state, pinRight=false) => {
    // if(section) {
    //   setPinData({ columnId, state, pinRight });
    //   return;
    // }
    //
    // pinColumn(columnId, state, pinRight);
    
    (section || structure).pinDescriptionColumn(columnId, state, pinRight);
  }
  const handleColumnRemove = (columnId, columnName) => {
    if(section) {
      setRemoveData({ columnId, columnName });
      return;
    }
    
    removeColumn(columnId);
  }
  const handleColumnVisibility = (columnId, state) => {
    structure.setBreakdownColumnVisibility(columnId, state)
  }
  
  const addNewColumn = (sectionId=undefined) => {
    structure.addDescriptionColumn(sectionId);
  }
  // const pinColumn = (columnId, state, pinRight) => {
  //   structure.pinDescriptionColumn(columnId, state, pinRight);
  // }
  const removeColumn = (columnId) => {
    structure.removeDescriptionColumn(columnId);
  }
  
  const handleAddAlertClose = (addToAll) => () => {
    addNewColumn(addToAll ? undefined : section?.id);
    showAddAlert(false);
  }
  // const handlePinAlertClose = (pinInAll) => () => {
  //   const { columnId, state, pinRight } = pinAlertData;
  //   if(pinInAll)
  //     pinColumn(columnId, state, pinRight);
  //   else
  //     section.pinDescriptionColumn(columnId, state, pinRight);
  //   setPinData(null);
  // }
  const handleRemoveAlertAccept = () => {
    removeColumn(removeAlertData.columnId);
    setRemoveData(null)
  }
  
  return (
    <Grid
      item container
      direction="column"
      wrap="nowrap"
      spacing={1}
      className="mb-4"
    >
      {
        !section &&
        <InfoLabel className="mt-0" label="views.editor.breakdown_columns" />
      }
      {
        filteredBreakdownColumns
          .map((columnSettings, index) => (
            <ColumnSettingEntry
              key={ columnSettings.id }
              columnSettings={columnSettings}
              onVisibilityChange={ handleColumnVisibility }
              onPin={ handleColumnPin }
              onRemove={ handleColumnRemove }
            >
              {
                index === lastDescriptionColumnIndex && !usedAllDescriptionColumns && !noDescriptionAdding &&
                <AddButtonFull
                  id="addDescriptionColumn"
                  size="small"
                  variant="text"
                  onClick={ handleColumnAdd }
                  className="-my-1 w-256"
                >
                  { t("views.editor.breakdown_table.add_description_column") }
                </AddButtonFull>
              }
            </ColumnSettingEntry>
          ))
      }
      {
        !filteredBreakdownColumns.length &&
        <span className="p-1 text-lighter">
          { t("views.editor.breakdown_table.no_sections") }
        </span>
      }
      <Alert
        title={t("views.editor.breakdown_table.alert_titles.remove")}
        isOpen={Boolean(removeAlertData)}
        cancelText={t("common.no")}
        acceptText={t("common.yes")}
        onCancel={() => setRemoveData(null)}
        onAccept={handleRemoveAlertAccept}
      />
      <Alert
        title={t("views.editor.breakdown_table.alert_titles.add")}
        isOpen={addAlertVisible}
        intermediateText={t("views.editor.breakdown_table.alert_titles.this_section")}
        acceptText={t("views.editor.breakdown_table.alert_titles.all_sections")}
        onCancel={() => showAddAlert(false)}
        onIntermediate={handleAddAlertClose(false)}
        onAccept={handleAddAlertClose(true)}
      />
      {/*<Alert*/}
      {/*  title="Do you want to pin this column in all sections or just this section?"*/}
      {/*  isOpen={Boolean(pinAlertData)}*/}
      {/*  cancelText={t("Just this section")}*/}
      {/*  acceptText={t("Pin in all sections")}*/}
      {/*  onCancel={handlePinAlertClose(false)}*/}
      {/*  onAccept={handlePinAlertClose(true)}*/}
      {/*/>*/}
    </Grid>
  )
})

BreakdownColumnsList.propTypes = {
  section: object,
  noDescriptionAdding: bool,
}